import {onFind} from "@elements/init-modules-in-scope";
import {on, trigger, findIn} from "@elements/dom-utils";
import Autocomplete from "../libs/autocomplete";
import axios from "axios";

export function init() {
    onFind('.js-typeahead__wrapper', function (wrapper) {
        let baseElement = findIn('.js-typeahead', wrapper);
        let hiddenInput = findIn('.js-typeahead__hidden-input', wrapper);
        let apiUrl = baseElement.dataset.apiUrl;
        console.log(apiUrl);
        let test = new Autocomplete(baseElement, {
            howManyCharacters: 2,
            cache: false,
            onSearch: ({currentValue}) => {
                const api = apiUrl+`?q=${encodeURI(
                    currentValue
                )}`;

                return axios({
                    url: api,
                    headers: {'X-Requested-With': 'XMLHttpRequest'},
                }).then((response) => response.data)
                    .then((result) => {
                        return result.data.options;
                    })
                    .catch((error) => {
                        console.error(error);
                    });
            },
            onResults: ({currentValue, matches, template}) => {
                return matches === 0
                    ? template
                    :matches
                        .map(({name, status}) => {
                            return `
                          <li class="">
                            ${name.replace(
                                new RegExp(currentValue, "gi"),
                                (str) => `<b>${str}</b>`
                            )}
                          </li>`;
                        })
                        .join("");
            },
            onSelectedItem: ({ element, object }) => {
                if (!object) return;
                element.value = object.name;
                trigger('change', element);
            },
            onSubmit: ({ index, element, object, results }) => {
                if (!object) return;
                element.value = object.name;
                trigger('change', element)
                hiddenInput.value = object.id;
                console.log(hiddenInput.value);
            },
            noResults: ({element, template}) =>
                template(`<li>No results found: "${element.value}"</li>`),
        });

    });
}


